/**
 * Created by chenzheyu on 2017/6/16.
 */
import XKcircuitMod from './src/circuitMod.vue'

XKcircuitMod.intall = function (Vue) {
  Vue.component(XKcircuitMod.name, XKcircuitMod)
}

export default XKcircuitMod



// WEBPACK FOOTER //
// ./src/components/module/circuitMod/index.js